export default __webpack_public_path__ + "static/media/logo_insea.a8f2b042.png";